import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useTUXContext } from '../TUXProvider/TUXProvider.js';

var TUXTableCell = function TUXTableCell(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      disabled = _ref.disabled,
      className = _ref.className,
      onClick = _ref.onClick,
      accessory = _ref.accessory,
      accessoryType = _ref.accessoryType,
      hostCanBeClick = _ref.hostCanBeClick,
      accessoryHasTextProps = _ref.accessoryHasTextProps,
      shouldWrapWithLabel = _ref.shouldWrapWithLabel;

  var _useTUXContext = useTUXContext(),
      platform = _useTUXContext.platform;

  var tableCellClass = useMemo(function () {
    return clsx('tux-table-cell__host w-full block', className, hostCanBeClick && !disabled && 'cell-can-be-click');
  }, [disabled, className, hostCanBeClick]);
  var tableCellAccessoryClass = useMemo(function () {
    return clsx('flex tux-table-cell__accessory flex-0', accessoryHasTextProps && (disabled ? 'text-color-TextQuaternary' : 'text-color-TextTertiary'), {
      'switch': {
        'iOS': 'tux-table-cell__accessory-switch_ios',
        'Android': 'tux-table-cell__accessory-switch_android'
      }[platform],
      'label': 'tux-table-cell__accessory-label',
      'disclosure': 'tux-table-cell__accessory-disclosure',
      'radio': 'tux-table-cell__accessory-radio',
      'checkbox': 'tux-table-cell__accessory-checkbox',
      'button': 'tux-table-cell__accessory-button'
    }[accessoryType]);
  }, [disabled, accessoryType, accessoryHasTextProps, platform]);

  var _ref2 = /*#__PURE__*/React.createElement("div", {
    className: tableCellAccessoryClass
  }, accessory);

  var TableCellCore = function TableCellCore() {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-16 py-16"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full flex flex-row"
    }, icon && /*#__PURE__*/React.createElement("div", {
      className: "tux-table-cell__icon w-20 h-20 me-12 " + (disabled ? 'text-color-TextQuaternary' : 'text-color-TextTertiary'),
      style: {
        fontSize: 20
      }
    }, icon), /*#__PURE__*/React.createElement("div", {
      className: "w-full flex flex-row items-start",
      style: {
        paddingTop: 1,
        paddingBottom: 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "tux-table-cell__title me-12 flex-1 flex-shrink-0 H4-Regular " + (disabled ? 'text-color-TextQuaternary' : 'text-color-TextPrimary')
    }, title), _ref2)), subTitle && /*#__PURE__*/React.createElement("div", {
      className: clsx('tux-table-cell__subtitle P3-Regular', disabled ? 'text-color-TextQuaternary' : 'text-color-TextTertiary', icon && 'ms-32'),
      style: {
        marginTop: accessoryType === 'button' || accessoryType === 'switch' ? 8 : 5
      }
    }, subTitle));
  };

  var onLabelContainerClick = function onLabelContainerClick(e) {
    if (e.target instanceof HTMLAnchorElement) {
      e.preventDefault();
    }

    if (disabled || onClick === undefined) {
      return;
    }

    onClick(e);
  };

  var onDivContainerClick = function onDivContainerClick(e) {
    if (disabled || onClick === undefined) {
      return;
    }

    onClick(e);
  };

  return shouldWrapWithLabel ? /*#__PURE__*/React.createElement("label", {
    className: tableCellClass,
    onClick: onLabelContainerClick,
    role: hostCanBeClick ? 'button' : undefined
  }, /*#__PURE__*/React.createElement(TableCellCore, null)) : /*#__PURE__*/React.createElement("div", {
    className: tableCellClass,
    onClick: onDivContainerClick,
    role: hostCanBeClick ? 'button' : undefined
  }, /*#__PURE__*/React.createElement(TableCellCore, null));
};

export { TUXTableCell };
//# sourceMappingURL=TUXTableCell.js.map
